<script>
    import {router} from './lib/Router/Router.svelte';
    import app from "./lib/stores/app.js";
    import department$ from "./lib/stores/department$.js";
    import PageHeader from "./lib/components/PageHeader.svelte";
    import OfferItem from "./offer/OfferItem.svelte";
    import Icon from "./lib/components/icons/Icon.svelte";
    import {emptyReservation, emptyRoute} from "./lib/js/reservation.js";
    import {PAYMENT_TYPE} from "./lib/js/constants.js";

    export let reservation;

    const selectOffer = ({detail}) => {
        $app.offer = detail;
        router.go(`/${$department$.link_code}/book-offer`)();
    }


    const selectTransfer = type => {
        $app.reservation_type = type;
        reservation = emptyReservation();
        reservation.routes.push(emptyRoute());

        router.go(`/${$department$.link_code}/book-transfer`)();
    }

    $app.offer = null;
    $app.reservation_type = null;
</script>

{#if $department$.payment_method == PAYMENT_TYPE.BANK}
    <PageHeader title="Regent Mile Partner Desk"
                subtitle="Manage and arrange transfers for your clients with ease" home/>
{:else}
    <PageHeader title="Your Private Chauffeur Experience in Crete"
                subtitle="Seamless, discreet, and tailored to your journey" home/>
{/if}

{#if $app.offers.length > 0}
    <div class="container offers-container">
        <div class="row">
            <div class="col-xl-2 col-lg-1 hidden-sm hidden-xs"></div>
            <div class="col-xl-8 col-lg-10">
                {#each $app.offers as offer (offer.id)}
                    <OfferItem {offer} on:select={selectOffer}/>
                {/each}
            </div>
        </div>
    </div>
{/if}

<div class="container py-lg">
    <div class="row">
        <div class="col-xl-2 col-lg-1 hidden-sm hidden-xs"></div>
        <div class="col-xl-8 col-lg-10">
            <div class="section-title mb-4">
                <h2 class="h4 mb-0">Where would you like to go?</h2>
            </div>

            <button class="route-button d-flex align-items-center gap-4 w-100 pt-2 pb-3"
                    on:click={() => selectTransfer('arrival')}>
            <span class="icons d-flex align-items-center">
                <span><Icon name="arrival-departure" size="24"/></span>
                &#10141;
                <span><Icon name="hotel" size="24"/></span>
            </span>
                <span class="content">
                <span class="title">Arrival Transfer</span>
                <span class="route">Airport or Port &#10141; Hotel</span>
                <span class="info">Meet & greet service included.</span>
            </span>
            </button>

            <button class="route-button d-flex align-items-center gap-4 w-100 py-3"
                    on:click={() => selectTransfer('departure')}>
            <span class="icons d-flex align-items-center">
                <span><Icon name="hotel" size="24"/></span>
                &#10141;
                <span><Icon name="arrival-departure" size="24"/></span>
            </span>
                <span class="content">
                <span class="title">Departure Transfer</span>
                <span class="route">Hotel &#10141; Airport or Port</span>
                <span class="info">Timely pickup with traffic planning.</span>
            </span>
            </button>

            <button class="route-button d-flex align-items-center gap-4 w-100 py-3"
                    on:click={() => selectTransfer('hotel')}>
            <span class="icons d-flex align-items-center">
                <span><Icon name="hotel" size="24"/></span>
                &#10141;
                <span><Icon name="map-pin" size="24"/></span>
            </span>
                <span class="content">
                <span class="title">Private Transfer to Another Destination</span>
                <span class="route">Hotel &#10141; Custom Location</span>
                <span class="info">Flexible scheduling.</span>
            </span>
            </button>

            <button class="route-button d-flex align-items-center gap-4 w-100 pt-3 pb-2"
                    on:click={() => selectTransfer('location')}>
            <span class="icons d-flex align-items-center">
                <span><Icon name="map-pin" size="24"/></span>
                &#10141;
                <span><Icon name="hotel" size="24"/></span>
            </span>
                <span class="content">
                <span class="title">Private Transfer to Your Hotel</span>
                <span class="route">Custom Location &#10141; Hotel</span>
                <span class="info">Door-to-door comfort.</span>
            </span>
            </button>
        </div>
    </div>
</div>

<style>
    .offers-container {
        /*margin-top: -790px;*/
        margin-top: calc(-100vh + 330px);
        min-height: 790px;
    }

    @media (max-width: 767px) {
        .offers-container {
            margin-top: calc(-100vh + 270px);
            min-height: 790px;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .offers-container {
            margin-top: calc(-100vh + 390px);
            min-height: 790px;
        }
    }

    .route-button .icons {
        gap: 10px;
        color: #000;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.17);
        padding: 30px 20px;
    }

    .route-button:hover .icons {
        color: #fff;
        background: #50ba87;
    }

    .route-button .content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        text-align: left;
        line-height: 1;
    }

    .route-button .title {
        display: block;
        font-size: 18px;
        font-weight: 500;
    }

    .route-button .info {
        font-size: 14px;
    }

    @media (max-width: 576px) {
        .route-button .icons {
            gap: 5px;
            padding: 30px 10px;
        }
    }
</style>
